<div class="container main-content-area">

<div class="terms-page card p-5 shadow">
    <h1>Terms and Conditions</h1>
    <p><strong>Effective Date:</strong> 1st May 2025</p>
    <p><strong>Website : </strong> <a href="https://www.lil-champs.com" target="_blank">www.lil-champs.com</a></p>
  
    <p>Welcome to Lil Champ’s Happy Bot! By using this website, you agree to the following terms and conditions:</p>
  
    <h3>1. Purpose of the Website</h3>
    <p>This platform is created to provide hygiene education and wellness resources for children and their guardians through videos, games, and readable materials.</p>
  
    <h3>2. Non-Commercial Use</h3>
    <p>All content is provided for educational and non-commercial use. You may view materials for personal or classroom use only.</p>
  
    <h3>3. Content Ownership</h3>
    <p>All content, including characters like Happy Bot, videos, illustrations, and games, are the intellectual property of the site creators or licensed partners.</p>
  
    <h3>4. Disclaimer</h3>
    <ul>
      <li>This site does not provide medical advice.</li>
      <li>The educational content is not a substitute for professional healthcare consultation.</li>
      <li>Always consult a qualified healthcare provider for specific concerns.</li>
    </ul>
  
    <h3>5. User Conduct</h3>
    <ul>
      <li>Do not misuse, modify, or redistribute website materials without permission.</li>
      <li>Do not attempt to access restricted parts of the site (if any).</li>
    </ul>
  
    <h3>6. Changes to Terms</h3>
    <p>We may update these terms periodically. Continued use of the site indicates acceptance of the updated terms.</p>
  
    <h3>7. Contact</h3>
    <p>For questions about these terms, email us at: <a href="mailto:support@lil-champs.com">support&#64;lil-champs.com
    </a></p>
  </div>
  
  </div>